export const projects = [
    {
        title: "Rate-My-Course",
        description:
        "This platform allows students to rate and review their courses, providing valuable insights into course quality, difficulty, and instructor effectiveness. By aggregating student feedback, it empowers users to make informed decisions about which courses align best with their academic goals and preferences.",
        tech: ["HTML", "JavaScript", "Node.js", "PostgreSQL", "Tailwind", "Vue"],
        link: "https://github.com/blin4504/rate-course",
    },
    {
        title: "Inventory Manager",
        description:
        "An Inventory Management Web Application designed to streamline the tracking, organization, and control of inventory across multiple locations. This application empowers businesses  to efficiently manage their stocks and ensure accurate record-keeping in real time.",
        tech: ["AWS", "JavaScript", "Next.js", "Node.js", "PostgreSQL", "React", "TailwindCSS"],
        link: "https://github.com/aw2755/inventory_manager",
    },
    {
        title: "Club Manager",
        description:
        "This Discord bot enables server members to join waitlist queues and automatically sends a customized embedded ping when it's their turn to play. The goal of this project was to ensure all club members could participate, fostering inclusion and helping those who may feel nervous or isolated join in the fun.",
        tech: ["Python", "Discord API"],
        link: "https://github.com/aw2755/BadmintonClubManager",
    },
    {
        title: "Developer Portfolio",
        description:
        "This personal portfolio showcases the projects I’ve completed, highlighting my skills and creativity across various development areas. It offers an in-depth look into the work I’m passionate about and the tools I’ve used to create them.",
        tech: ["HTML", "JavaScript", "React", "TailwindCSS"],
        link: "https://github.com/aw2755/alan_wang",
    },
    {
        title: "Fruit E-store",
        description:
        "A fruit e-store developed collaboratively with a team of four classmates as an introductory project, designed to explore and learn new software tools and development practices.",
        tech: ["Angular", "Java", "JUnit", "Spring Boot", "Typescript"],
        link: "https://github.com/aw2755/estore",
    },
];